import { render, staticRenderFns } from "./ThirdPage.vue?vue&type=template&id=8e4b6c92&scoped=true"
import script from "./ThirdPage.vue?vue&type=script&lang=js"
export * from "./ThirdPage.vue?vue&type=script&lang=js"
import style0 from "./ThirdPage.vue?vue&type=style&index=0&id=8e4b6c92&prod&lang=scss&scoped=true"
import style1 from "./ThirdPage.vue?vue&type=style&index=1&id=8e4b6c92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4b6c92",
  null
  
)

export default component.exports